export const uz: Record<string, string> = {
  // ===== NAVIGATION =====
  'nav.dashboard': 'Bosh sahifa',
  'nav.liveMap': 'Jonli xarita',
  'nav.main': 'ASOSIY',
  'nav.users': 'Foydalanuvchilar',
  'nav.allUsers': 'Barchasi',
  'nav.passengers': "Yo'lovchilar",
  'nav.drivers': 'Haydovchilar',
  'nav.documents': 'Hujjatlar',
  'nav.insurance': "Sug'urta",
  'insurance.title': "Sug'urta muddati",
  'insurance.vehicle': 'Avtomobil',
  'insurance.expiryDate': 'Tugash sanasi',
  'insurance.daysLeft': 'Qolgan kunlar',
  'insurance.noData': "Ma'lumot yo'q",
  'insurance.expiredPrefix': 'Tugagan',
  'insurance.daysSuffix': 'kun oldin',
  'insurance.expiresToday': 'Bugun tugaydi',
  'insurance.daysLeftSuffix': 'kun qoldi',
  'insurance.sendPush': 'Push-xabar yuborish',
  'insurance.sendPushTitle': "Sug'urta haqida eslatma",
  'insurance.sendPushConfirm': "Haydovchiga sug'urta muddati haqida push-xabar yuborilsinmi?",
  'insurance.pushSent': 'Push-xabar yuborildi',
  'insurance.pushNoToken': "Haydovchining qurilmasi ulanmagan (FCM token yo'q)",
  'insurance.pushFailed': 'Push-xabarni yuborib bo\'lmadi',
  'insurance.pickDate': 'Sanani tanlang',
  'insurance.savedExpiry': "Sug'urta sanasi saqlandi",
  'insurance.saveFailed': "Sug'urta sanasini saqlab bo'lmadi",
  'drivers.insuranceExpiry': "Sug'urta tugash sanasi",
  'common.notActive': 'Faol emas',
  'insurance.lastReminder': 'Oxirgi xabarnoma',
  'insurance.history': "Xabarnomalar tarixi",
  'insurance.historyTitle': "Xabarnomalar tarixi",
  'insurance.historyEmpty': "Hali xabarnoma yuborilmagan",
  'insurance.delivered': 'Yetkazildi',
  'insurance.notDelivered': "Yetkazilmadi",
  'insurance.cantNotifyNoData': "Sug'urta sanasi yo'q — xabarnoma yuborib bo'lmaydi",
  'insurance.remindedThisWeek': 'Bu hafta xabar yuborilgan haydovchilar',
  'insurance.reminderManual': 'Qo\'lda',
  'insurance.reminderAuto2w': 'Avto · 2 hafta',
  'insurance.reminderAuto1w': 'Avto · 1 hafta',
  'insurance.reminderAuto1d': 'Avto · 1 kun',

  // Phase 3 — trip detail admin sections
  'trips.adminNotes': 'Admin izohlari',
  'trips.adminNotesPlaceholder': 'Izoh yozing...',
  'trips.adminNotesEmpty': 'Hali izoh yo\'q',
  'trips.commissionTitle': 'Komissiya',
  'trips.commissionTaken': 'Yechilgan komissiya',
  'trips.commissionRefunded': 'Qaytarilgan komissiya',
  'trips.driverNetEarnings': 'Haydovchi sof daromadi',
  'trips.commissionStateDeducted': 'Yechilgan',
  'trips.commissionStateRefunded': 'Qaytarilgan',
  'trips.commissionStateNone': 'Komissiya yo\'q',
  'trips.autoFindTimeline': 'Avto-qidiruv tarixi',
  'trips.autoFindTimelineEmpty': 'Hali voqea yo\'q',
  'trips.routeMap': 'Marshrut xaritasi',
  'trips.routeMapLive': 'Jonli',
  'trips.pickup': 'Olib ketish',
  'trips.destination': 'Manzil',
  'trips.assignDriverTitle': 'Haydovchi tayinlash',
  'trips.assignDriverButton': 'Haydovchi tayinlash',
  'trips.replaceDriverTitle': 'Haydovchini almashtirish',
  'trips.replaceDriverButton': 'Almashtirish',
  'trips.currentDriver': 'Hozirgi haydovchi',
  'trips.noDriverAssigned': 'Haydovchi tayinlanmagan',
  'trips.driverSearchPlaceholder': 'ID, ism yoki telefon bo\'yicha qidirish',
  'trips.reassignReason': 'Almashtirish sababi',
  'trips.reassignReasonPlaceholder': 'Nima uchun haydovchi almashtirilyapti?',
  'trips.reassignFinancialWarning':
    'Diqqat: oldingi haydovchining komissiyasi qaytariladi, yangi haydovchidan komissiya yechiladi.',
  'trips.assignFinancialWarning': 'Tayinlangach yangi haydovchidan komissiya yechiladi.',
  'trips.autoFindLockoutHint':
    'Avto-qidiruv hali ishlamoqda (90 soniya). Tugashini kuting yoki sayohat ommaviy bo\'lishini kuting.',
  'nav.trips': 'Sayohatlar',
  'nav.allTrips': 'Barcha sayohatlar',
  'nav.driverTrips': 'Haydovchi sayohatlari',
  'nav.bookings': 'Buyurtmalar',
  'nav.yolYolakayOffers': 'Savdolashish takliflari',
  'nav.finance': 'MOLIYA',
  'nav.payments': "To'lovlar",
  'nav.pricing': 'Narxlash',
  'nav.tariffs': 'Tariflar',
  'tariffs.title': 'Tariflar',
  'tariffs.name': 'Tarif',
  'tariffs.available': 'Faol',
  'tariffs.order': 'Tartib',
  'tariffs.saved': 'Saqlandi',
  'tariffs.saveFailed': "Saqlab bo'lmadi",
  'tariffs.loadFailed': "Tariflarni yuklab bo'lmadi",
  'tariffs.cars': 'Avtomobillar',
  'tariffs.trips': 'Sayohatlar',
  'tariffs.inactive': 'Nofaol',
  'nav.promoCodes': 'Promo kodlar',
  'nav.trackingLinks': 'Marketing havolalari',
  'trackingLinks.new': 'Yangi havola',
  'trackingLinks.name': 'Nomi',
  'trackingLinks.channel': 'Kanal',
  'trackingLinks.link': 'Havola',
  'trackingLinks.clicks': 'Bosilgan',
  'trackingLinks.basicInfo': "Asosiy ma'lumot",
  'nav.incentives': "Rag'batlantirish",
  'nav.referrals': 'Referal dasturi',
  'nav.support': "QO'LLAB-QUVVATLASH",
  'nav.supportTickets': 'Murojatlar',
  'nav.emergency': 'Favqulotda chatlar',
  'nav.suggestions': 'Takliflar',
  'nav.chat': 'Chat xabarlari',
  'nav.faq': 'FAQ',
  'nav.config': 'SOZLAMALAR',
  'nav.locations': 'Joylar',
  'nav.tutorials': "Qo'llanmalar",
  'nav.carBrands': 'Avtomobil markalari',
  'nav.cancellationReasons': 'Bekor qilish sabablari',
  'nav.faollikBali': 'Faollik bali',
  'nav.appUpdates': 'Yangilanishlar',
  'nav.notifications': 'Bildirishnomalar',
  'nav.staff': 'Xodimlar',
  'nav.auditLog': 'Audit log',
  'nav.withdrawals': "Pul yechish so'rovlari",
  'nav.settings': 'Sozlamalar',
  'nav.analytics': 'ANALITIKA',
  'nav.analyticsPage': 'Analitika',
  'nav.reports': 'Hisobotlar',
  'nav.busCompanies': 'Kompaniyalar',
  'nav.busCompanyProfile': "Bizning ma'lumotlar",
  'nav.busTrips': 'Reyslar',

  // ===== COMMON =====
  'common.search': 'Qidirish...',
  'common.save': 'Saqlash',
  'common.cancel': 'Bekor qilish',
  'common.delete': "O'chirish",
  'common.edit': 'Tahrirlash',
  'common.create': 'Yaratish',
  'common.back': 'Orqaga',
  'common.view': "Ko'rish",
  'common.confirm': 'Tasdiqlash',
  'common.actions': 'Amallar',
  'common.status': 'Holat',
  'common.date': 'Sana',
  'common.loading': 'Yuklanmoqda...',
  'common.noData': "Ma'lumot yo'q",
  'common.total': 'Jami',
  'common.history': 'Tarix',
  'common.yes': 'Ha',
  'common.no': "Yo'q",
  'common.active': 'Faol',
  'common.inactive': 'Nofaol',
  'common.all': 'Barchasi',
  'common.export': 'Eksport',
  'common.send': 'Yuborish',
  'common.close': 'Yopish',
  'common.resolve': 'Hal qilish',
  'common.approve': 'Tasdiqlash',
  'common.reject': 'Rad etish',
  'common.block': 'Bloklash',
  'common.unblock': 'Faollashtirish',
  'common.error': 'Xatolik yuz berdi',
  'common.success': 'Muvaffaqiyatli',
  'common.logout': 'Chiqish',
  'common.collapseMenu': 'Menyuni yopish',
  'common.filter': 'Filtrlash',
  'common.reset': 'Tozalash',
  'common.apply': "Qo'llash",
  'common.details': 'Tafsilotlar',
  'common.phone': 'Telefon',
  'common.name': 'Ism',
  'common.id': 'ID',
  'common.add': "Qo'shish",
  'common.confirmDelete': "O'chirishni tasdiqlaysizmi?",
  'common.driver': 'Haydovchi',
  'common.vehicle': 'Avtomobil',
  'common.createdAt': 'Yaratilgan',
  'common.updatedAt': 'Yangilangan',
  'common.sum': "so'm",
  'common.reason': 'Sabab',
  'common.description': 'Tavsif',
  'common.type': 'Turi',
  'common.price': 'Narx',
  'common.amount': 'Miqdor',
  'common.noName': 'Ismsiz',

  // ===== TABLE COLUMNS =====
  'table.user': 'Foydalanuvchi',
  'table.role': 'Rol',
  'table.status': 'Holat',
  'table.rating': 'Reyting',
  'table.trips': 'Sayohatlar',
  'table.registered': "Ro'yxatdan o'tgan",
  'table.actions': 'Amallar',
  'table.subject': 'Mavzu',
  'table.driver': 'Haydovchi',
  'table.client': 'Mijoz',
  'table.route': "Yo'nalish",
  'table.tripType': 'Sayohat turi',
  'table.price': 'Narx',
  'table.date': 'Sana',
  'table.waitingTime': 'Kutish vaqti',
  'table.paymentMethod': "To'lov usuli",
  'table.verified': 'Tasdiqlangan',

  // ===== STATUSES =====
  'status.online': 'Online',
  'status.offline': 'Offline',
  'status.blocked': 'Bloklangan',
  'status.resting': 'Dam olmoqda',
  'status.requested': "So'ralgan",
  'status.accepted': 'Qabul qilingan',
  'status.driverArrived': 'Haydovchi yetib keldi',
  'status.pickedUp': 'Olib ketildi',
  'status.onTheWay': "Yo'lda",
  'status.inProgress': 'Jarayonda',
  'status.completed': 'Yakunlangan',
  'status.cancelled': 'Bekor qilingan',
  'status.interrupted': "To'xtatilgan",
  'status.noShow': 'Kelmadi',
  'status.active': 'Faol',
  'status.matched': 'Mos topildi',
  'status.expired': 'Muddati tugagan',
  'status.open': 'Ochiq',
  'status.inProgressTicket': 'Jarayonda',
  'status.resolved': 'Hal qilingan',
  'status.closed': 'Yopilgan',
  'status.pending': 'Kutilmoqda',
  'status.approved': 'Tasdiqlangan',
  'status.rejected': 'Rad etilgan',
  'status.new': 'Yangi',
  'status.underReview': "Ko'rib chiqilmoqda",
  'status.accepted_suggestion': 'Qabul qilingan',
  'status.closedSuggestion': 'Yopilgan',

  // ===== ROLES =====
  'role.client': 'Mijoz',
  'role.driver': 'Haydovchi',
  'role.admin': 'Admin',
  'role.passenger': "Yo'lovchi",

  // ===== TRIP TYPES =====
  'tripType.intercityTaxi': "Shaharlararo taksi",
  'tripType.interregionTaxi': 'Viloyatlararo taksi',
  'tripType.shaharlarAro': 'Viloyat ichida',
  'tripType.yolYolakay': 'Savdolashish',
  'tripType.postage': 'Pochta/Yuklarni yetkazish',
  'tripType.cargo': 'Katta yuk',

  // ===== PAYMENT =====
  'payment.cash': 'Naqd',
  'payment.uzcard': 'UzCard',
  'payment.humo': 'Humo',
  'payment.paid': "To'langan",
  'payment.unpaid': "To'lanmagan",

  // ===== DASHBOARD =====
  'dashboard.title': 'Bosh sahifa',
  'dashboard.taxiManagement': 'Taksi boshqaruvi',
  'dashboard.busManagement': 'Avtobus boshqaruvi',
  'dashboard.onlineDrivers': 'Online haydovchilar',
  'dashboard.activeTrips': 'Faol sayohatlar',
  'dashboard.todayRevenue': 'Bugungi daromad',
  'dashboard.commissionDeducted': "Yechilgan komissiyalar",
  'dashboard.driverTopups': "Haydovchilar to'ldirgan summa",
  'dashboard.adminTopups': "Admin to'ldirgan summa",
  'dashboard.pendingDocs': 'Kutilayotgan hujjatlar',
  'dashboard.newUsers': 'Yangi foydalanuvchilar',
  'dashboard.openTickets': 'Ochiq murojaatlar',
  'dashboard.completedOrders': 'Yakunlangan buyurtmalar',
  'dashboard.completedOrders.interregion': 'Viloyatlar aro',
  'dashboard.completedOrders.shaharlarAro': 'Viloyat ichida',
  'dashboard.completedOrders.yolYolakay': 'Savdolashish',
  'dashboard.completedOrders.postage': 'Pochta',
  'dashboard.comparedYesterday': 'oldingi davrga nisbatan',
  'dashboard.range.today': 'Bugun',
  'dashboard.range.yesterday': 'Kecha',
  'dashboard.range.thisWeek': 'Bu hafta',
  'dashboard.range.thisMonth': 'Bu oy',
  'dashboard.range.thisYear': 'Bu yil',
  'dashboard.range.allTime': 'Umumiy',
  'dashboard.activeNow': 'Hozir faol',
  'dashboard.viewOnMap': "Jonli xaritada ko'rish",
  'dashboard.keyMetrics': "Asosiy ko'rsatkichlar",
  'dashboard.quickActions': 'Tezkor amallar',
  'dashboard.recentActivity': 'Oxirgi faoliyat',
  'dashboard.noActivity': "Faoliyat yo'q",
  // Bus dashboard
  'dashboard.companies': 'Kompaniyalar',
  'dashboard.totalCompanies': 'Jami kompaniyalar',
  'dashboard.activeCompanies': 'Faol kompaniyalar',
  'dashboard.totalTrips': 'Jami reyslar',
  'dashboard.todayTrips': 'Bugungi reyslar',
  'dashboard.scheduledTrips': 'Rejalashtirilgan reyslar',
  'dashboard.bookings': 'Buyurtmalar',
  'dashboard.totalBookings': 'Jami buyurtmalar',
  'dashboard.todayBookings': 'Bugungi buyurtmalar',
  'dashboard.revenue': 'Daromad',
  'dashboard.totalRevenue': 'Jami daromad',
  // Audit log actions
  'audit.companyCreated': 'Kompaniya yaratildi',
  'audit.companyUpdated': 'Kompaniya yangilandi',
  'audit.tripCreated': 'Reys yaratildi',
  'audit.tripUpdated': 'Reys yangilandi',
  'audit.tripCancelled': 'Reys bekor qilindi',
  'audit.bookingCreated': 'Buyurtma yaratildi',
  'audit.bookingConfirmed': 'Buyurtma tasdiqlandi',
  'audit.bookingCancelled': 'Buyurtma bekor qilindi',
  'audit.stationCreated': 'Bekat yaratildi',
  'audit.layoutCreated': 'Joylashuv yaratildi',
  'audit.staffCreated': 'Xodim yaratildi',
  'audit.staffUpdated': 'Xodim yangilandi',
  'audit.staffDeleted': "Xodim o'chirildi",
  'audit.ticketReplied': 'Murojatga javob berildi',
  'audit.ticketResolved': 'Murojat hal qilindi',
  'audit.faqCreated': 'FAQ yaratildi',
  'audit.faqUpdated': 'FAQ yangilandi',
  'audit.promoCreated': 'Promo kod yaratildi',
  'audit.settingsUpdated': 'Sozlamalar yangilandi',
  'audit.walletTopup': "Hisob to'ldirildi",
  'audit.walletDeduct': 'Hisobdan yechildi',

  // ===== USERS =====
  'usersStats.total': 'Jami foydalanuvchilar',
  'usersStats.drivers': 'Haydovchilar',
  'usersStats.passengers': "Yo'lovchilar",
  'usersStats.online': 'Online (haydovchi + yo\'lovchi)',
  'usersStats.blocked': 'Bloklangan',
  'usersStats.newThisMonth': 'Bu oyda yangi',

  'passengersStats.total': "Jami yo'lovchilar",
  'passengersStats.online': 'Online',
  'passengersStats.blocked': 'Bloklangan',
  'passengersStats.newThisMonth': 'Bu oyda yangi',
  'passengersStats.totalTrips': 'Jami sayohatlar',
  'passengersStats.averageRating': "O'rtacha reyting",

  'users.allUsers': 'Barcha foydalanuvchilar',
  'users.title': 'Foydalanuvchilar',
  'users.name': "To'liq ism",
  'users.phone': 'Telefon',
  'users.role': 'Rol',
  'users.rating': 'Reyting',
  'users.trips': 'Sayohatlar',
  'users.registered': "Ro'yxatdan o'tgan",
  'users.balance': 'Balans',
  'users.viewAsPassenger': "Yo'lovchi sifatida",
  'users.viewAsDriver': 'Haydovchi sifatida',
  'users.bonusBalance': 'Bonus balans',
  'users.wallet': 'Hamyon',
  'users.addFunds': "Qo'shish",
  'users.deductFunds': 'Ayirish',
  'users.blockUser': 'Foydalanuvchini bloklash',
  'users.blockReason': 'Bloklash sababi',
  'users.tripHistory': 'Sayohatlar tarixi',
  'users.statistics': 'Statistika',
  'users.information': "Ma'lumotlar",
  'users.editUser': 'Foydalanuvchini tahrirlash',
  'users.enterName': 'Ismni kiriting',
  'users.nameRequired': "Ism to'ldirilishi shart",
  'users.userBlocked': 'Foydalanuvchi bloklandi',
  'users.userUnblocked': 'Foydalanuvchi blokdan chiqarildi',
  'users.userEdited': 'Foydalanuvchi tahrirlandi',
  'users.blockConfirm': 'Foydalanuvchini bloklaysizmi?',
  'users.unblockConfirm': 'Foydalanuvchini blokdan chiqarasizmi?',
  'users.blockReasonPlaceholder': 'Bloklash sababini kiriting...',
  'users.enterBlockReason': 'Bloklash sababini kiriting',
  'users.walletAddTitle': "Balansga qo'shish",
  'users.walletDeductTitle': 'Balansdan ayirish',
  'users.amountLabel': 'Miqdor',
  'users.amountRequired': "Miqdor to'ldirilishi shart",
  'users.amountPositive': "Miqdor musbat bo'lishi kerak",
  'users.reasonLabel': 'Sabab',
  'users.reasonRequired': "Sabab to'ldirilishi shart",
  'users.balanceAdded': "Balansga muvaffaqiyatli qo'shildi",
  'users.balanceDeducted': 'Balansdan muvaffaqiyatli ayirildi',
  'users.tripsNotFound': "Sayohatlar topilmadi",

  // ===== PASSENGERS =====
  'passengers.title': "Yo'lovchilar",

  // ===== DRIVERS =====
  'drivers.title': 'Haydovchilar',
  'drivers.newDriver': 'Yangi haydovchi',
  'drivers.verified': 'Tasdiqlangan',
  'drivers.notVerified': 'Tasdiqlanmagan',
  'drivers.verify': 'Tasdiqlash',
  'drivers.rejectDriver': 'Rad etish',
  'drivers.vehicle': 'Avtomobil',
  'drivers.transactions': 'Tranzaksiyalar',
  'drivers.viewProfile': "Profilni ko'rish",
  'drivers.personalInfo': "Shaxsiy ma'lumotlar",
  'drivers.personalInfoHelp': "Haydovchining shaxsiy ma'lumotlari",
  'drivers.vehicleInfo': "Avtomobil ma'lumotlari",
  'drivers.vehicleInfoHelp': "Avtomobil haqida ma'lumot",
  'drivers.fullName': "To'liq ism",
  'drivers.fullNameHelp': "Haydovchining to'liq ismi",
  'drivers.enterName': 'Ismni kiriting',
  'drivers.namePlaceholder': 'Masalan: Abdullayev Jasur',
  'drivers.phoneNumber': 'Telefon raqam',
  'drivers.phoneHelp': "Haydovchining telefon raqami",
  'drivers.enterPhone': 'Telefon raqamni kiriting',
  'drivers.birthDate': "Tug'ilgan sana",
  'drivers.birthDateHelp': "Haydovchining tug'ilgan sanasi",
  'drivers.selectDate': 'Sanani tanlang',
  'drivers.vehicleMake': 'Avtomobil markasi',
  'drivers.vehicleMakeHelp': 'Avtomobil ishlab chiqaruvchisi',
  'drivers.enterMake': 'Markani kiriting',
  'drivers.makePlaceholder': 'Masalan: Chevrolet',
  'drivers.vehicleModel': 'Avtomobil modeli',
  'drivers.vehicleModelHelp': 'Avtomobil modeli',
  'drivers.enterModel': 'Modelni kiriting',
  'drivers.modelPlaceholder': 'Masalan: Malibu',
  'drivers.vehicleYear': 'Ishlab chiqarilgan yil',
  'drivers.vehicleYearHelp': 'Avtomobil ishlab chiqarilgan yili',
  'drivers.enterYear': 'Yilni kiriting',
  'drivers.vehicleColor': 'Avtomobil rangi',
  'drivers.vehicleColorHelp': 'Avtomobil rangi',
  'drivers.enterColor': 'Rangni kiriting',
  'drivers.colorPlaceholder': "Masalan: Oq",
  'drivers.vehiclePlate': 'Davlat raqami',
  'drivers.vehiclePlateHelp': 'Avtomobil davlat raqami',
  'drivers.enterPlate': 'Davlat raqamini kiriting',
  'drivers.vehicleSeats': "O'rindiqlar soni",
  'drivers.vehicleSeatsHelp': "Mavjud yo'lovchi o'rindiqlari",
  'drivers.driverVerified': 'Haydovchi tasdiqlandi',
  'drivers.driverBlocked': 'Haydovchi bloklandi',
  'drivers.driverUnblocked': 'Haydovchi blokdan chiqarildi',
  'drivers.driverRejected': 'Haydovchi rad etildi',
  'drivers.verifyConfirm': 'Haydovchini tasdiqlaysizmi?',
  'drivers.blockConfirm': 'Haydovchini bloklaysizmi?',
  'drivers.unblockConfirm': 'Haydovchini blokdan chiqarasizmi?',
  'drivers.walletBalance': 'Hamyon balansi',
  'drivers.addBalance': "Balansga qo'shish",
  'drivers.deductBalance': 'Balansdan ayirish',
  'drivers.vehicles': 'Avtomobillar',
  'drivers.transactionHistory': 'Tranzaksiyalar tarixi',
  'drivers.documents': 'Hujjatlar',
  'drivers.tripHistory': 'Sayohatlar tarixi',
  'drivers.rejectTitle': 'Haydovchini rad etish',
  'drivers.rejectReasonPlaceholder': 'Rad etish sababini kiriting...',
  'drivers.enterRejectReason': 'Rad etish sababini kiriting',
  // Transaction types
  'transaction.tripPayment': "Sayohat to'lovi",
  'transaction.commission': 'Komissiya',
  'transaction.walletTopup': "Hamyonni to'ldirish",
  'transaction.walletWithdrawal': 'Pul yechish',
  'transaction.bonus': 'Bonus',
  'transaction.bonusUsed': 'Bonus ishlatildi',
  'transaction.referralBonus': 'Referal bonus',
  'transaction.incentiveBonus': "Rag'bat bonusi",
  'transaction.refund': 'Qaytarish',
  // Document types
  'document.driverLicense': 'Haydovchilik guvohnomasi (old)',
  'document.driverLicenseBack': 'Haydovchilik guvohnomasi (orqa)',
  'document.selfie': 'Selfi',
  'document.techPassport': 'Texnik pasport (oldi)',
  'document.techPassportBack': 'Texnik pasport (orqa)',
  'document.carFront': 'Avtomobil oldi',
  'document.carBack': 'Avtomobil orqasi',
  'document.carLeft': "Avtomobil chap tomoni",
  'document.carRight': "Avtomobil o'ng tomoni",
  'document.carInterior': 'Avtomobil ichki qismi',
  'document.carTrunk': 'Avtomobil yukxonasi',
  'document.carBackSeats': "Orqa o'rindiqlar",
  'document.carFrontSeat': "Old o'rindiq",

  // Activity score reasons
  'activity.tripCompleted': 'Safar yakunlandi',
  'activity.fiveStarBonus': "5 yulduz uchun bonus",
  'activity.fourStarBonus': "4 yulduz uchun bonus",
  'activity.lowRating2Star': "Past baho (2 yulduz)",
  'activity.lowRating1Star': "Past baho (1 yulduz)",
  'activity.driverCancelled': 'Haydovchi bekor qildi',
  'activity.driverRejected': 'Haydovchi rad etdi',
  'activity.driverNoShow': 'Haydovchi kelmadi',
  'activity.adminAdjustment': 'Administrator tuzatdi',
  'activity.blockRecoveryReset': 'Blokdan qaytarish (reset)',
  'activity.autoBlocked': 'Avtomatik bloklangan',

  // Transaction types
  'transactionType.tripPayment': "Safar to'lovi",
  'transactionType.commission': 'Komissiya',
  'transactionType.bonusCredit': "Bonus qo'shildi",
  'transactionType.bonusDebit': 'Bonus ishlatildi',
  'transactionType.refund': 'Qaytarish',
  'transactionType.referralBonus': 'Referal bonus',
  'transactionType.incentiveBonus': "Rag'bat bonusi",
  'transactionType.walletTopup': "Hamyon to'ldirildi",
  'transactionType.walletWithdrawal': 'Hamyondan ayirildi',

  // ===== DOCUMENTS =====
  'documents.title': 'Hujjatlar',
  'documents.pending': 'Kutilmoqda',
  'documents.approved': 'Tasdiqlangan',
  'documents.rejected': 'Rad etilgan',
  'documents.expiry': 'Amal qilish muddati',
  'documents.expiringSoon': 'Tez orada tugaydi',
  'documents.expired': "Muddati o'tgan",
  'documents.notSet': 'Belgilanmagan',
  'documents.approveAll': 'Barchasini tasdiqlash',
  'documents.rejectAll': 'Barchasini rad etish',
  'documents.selected': 'ta tanlangan',
  'documents.viewDriverProfile': "Haydovchi profilini ko'rish",
  'documents.userDocuments': 'Foydalanuvchi hujjatlari',
  'documents.image': 'Rasm',
  'documents.documentType': 'Hujjat turi',
  'documents.approveSuccess': 'Hujjat tasdiqlandi',
  'documents.rejectSuccess': 'Hujjat rad etildi',
  'documents.replaceFile': 'Faylni almashtirish',
  'documents.fileReplaced': 'Fayl yangilandi',

  // ===== TRIPS =====
  'trips.title': 'Sayohatlar',
  'trips.newTrip': 'Yangi sayohat',
  'trips.tripDetails': 'Sayohat tafsilotlari',
  'trips.ratings': 'Baholar',
  'trips.chatMessages': 'Chat xabarlari',
  'trips.route': "Yo'nalish",
  'trips.payment': "To'lov",
  'trips.timeline': 'Vaqt chizig\'i',
  'trips.passengerCount': "Yo'lovchilar soni",
  'trips.pickupRegion': 'Chiqish viloyati',
  'trips.pickupAddress': 'Chiqish manzili',
  'trips.destinationRegion': 'Borilish viloyati',
  'trips.destinationAddress': 'Borilish manzili',
  'trips.distance': 'Masofa',
  'trips.estimatedTime': 'Taxminiy vaqt',
  'trips.estimatedPrice': 'Taxminiy narx',
  'trips.clientOffer': 'Mijoz taklifi',
  'trips.finalPrice': 'Yakuniy narx',
  'trips.paymentMethod': "To'lov usuli",
  'trips.surgeMultiplier': 'Surge koeffitsienti',
  'trips.forceCancel': 'Majburiy bekor qilish',
  'trips.forceComplete': 'Majburiy yakunlash',
  'trips.forceCancelConfirm': 'Sayohatni majburiy bekor qilasizmi?',
  'trips.forceCompleteConfirm': 'Sayohatni majburiy yakunlaysizmi?',
  'trips.tripCancelled': 'Sayohat bekor qilindi',
  'trips.tripCompleted': 'Sayohat yakunlandi',
  'trips.cancelledBy': 'Bekor qilgan',
  'trips.cancelActor.client': 'Mijoz',
  'trips.cancelActor.driver': 'Haydovchi',
  'trips.cancelActor.admin': 'Administrator',
  'trips.cancelActor.system': 'Tizim',
  'trips.cancelReason': 'Bekor qilish sababi',
  'trips.cancelNote': 'Izoh',
  'trips.clientInfo': "Mijoz ma'lumotlari",
  'trips.driverInfo': "Haydovchi ma'lumotlari",
  'trips.vehicleInfo': "Avtomobil ma'lumotlari",
  'trips.vehicleMakeModel': 'Marka va model',
  'trips.vehiclePlate': 'Davlat raqami',
  'trips.vehicleColor': 'Rang',
  'trips.addRating': "Baho qo'shish",
  'trips.whoRates': 'Kim baholaydi',
  'trips.ratingScore': 'Ball',
  'trips.ratingComment': 'Izoh',
  'trips.ratingAdded': "Baho qo'shildi",
  'trips.noRatings': "Baholar yo'q",
  'trips.noChatMessages': "Chat xabarlari yo'q",
  'trips.waitingTime': 'Kutish vaqti',
  'trips.tripType': 'Sayohat turi',
  'trips.client': 'Mijoz',
  'trips.driver': 'Haydovchi',
  'trips.price': 'Narx',
  // Time units
  'time.day': 'kun',
  'time.hour': 'soat',
  'time.minute': 'daqiqa',
  'time.second': 'soniya',
  // Yol-yolakay specific
  'trips.datePreference': 'Sana afzalligi',
  'trips.preferredTime': 'Afzal vaqt',
  'trips.showOnMap': "Xaritada ko'rsatish",
  'trips.comment': 'Izoh',
  'trips.expiration': 'Amal qilish muddati',
  'trips.targetDriver': "Mo'ljallangan haydovchi",
  'trips.dateNow': 'Hozir',
  'trips.dateToday': 'Bugun',
  'trips.dateTomorrow': 'Ertaga',
  // Additional trip destinations
  'trips.destinations': 'Manzillar',
  'trips.moreDestinations': "Qo'shimcha manzillar",

  // ===== LIVE MAP =====
  'liveMap.title': 'Jonli xarita',
  'liveMap.realtime': 'Real vaqt',
  'liveMap.drivers': 'Haydovchilar',
  'liveMap.trips': 'Sayohatlar',
  'liveMap.region': 'Viloyat',
  'liveMap.onlineDrivers': 'Online haydovchilar',
  'liveMap.activeTrips': 'Faol sayohatlar',
  'liveMap.pendingRequests': "Kutilayotgan so'rovlar",
  'liveMap.regionStats': 'Viloyatlar statistikasi',
  'liveMap.connected': 'Ulangan',
  'liveMap.disconnected': 'Uzilgan',
  'liveMap.reconnecting': 'Qayta ulanmoqda',
  'liveMap.driverPhone': 'Haydovchi telefoni',
  'liveMap.driverStatus': 'Haydovchi holati',
  'liveMap.driverVehicle': 'Haydovchi avtomobili',
  'liveMap.lastUpdate': 'Oxirgi yangilanish',
  'liveMap.viewProfile': "Profilni ko'rish",
  'liveMap.tripId': 'Sayohat ID',
  'liveMap.tripType': 'Sayohat turi',
  'liveMap.tripStatus': 'Sayohat holati',
  'liveMap.tripClient': 'Mijoz',
  'liveMap.tripDriver': 'Haydovchi',
  'liveMap.tripPickup': 'Chiqish nuqtasi',
  'liveMap.tripDestination': 'Borilish nuqtasi',
  'liveMap.tripDetails': 'Sayohat tafsilotlari',
  'liveMap.noActiveTrips': "Faol sayohatlar yo'q",
  'liveMap.noOnlineDrivers': "Online haydovchilar yo'q",
  'liveMap.driverCount': 'Haydovchilar soni',
  'liveMap.tripCount': 'Sayohatlar soni',
  'liveMap.postedTrips': "E'lon qilingan sayohatlar",
  'liveMap.noPostedTrips': "Faol e'lon qilingan sayohatlar yo'q",
  'liveMap.viloyatlarAro': 'Viloyatlar aro',
  'liveMap.viloyatIchida': 'Viloyat ichida',
  'liveMap.seatsLeft': "joy bo'sh",
  'liveMap.postedStatus.ACTIVE': 'Faol',
  'liveMap.postedStatus.FULL': "To'la",
  'liveMap.postedStatus.DEPARTED': "Yo'lda",
  'liveMap.openProfile': "Profilni yangi oynada ochish",
  'liveMap.openTrip': "E'lonni yangi oynada ochish",
  'liveMap.activePostedTrip': "Faol e'lon",
  'liveMap.noActivePostedTrip': "Faol e'lon yo'q",
  'liveMap.fullscreen': "To'liq ekran rejimi",
  'liveMap.exitFullscreen': "To'liq ekrandan chiqish (Esc)",

  // ===== SETTINGS =====
  'settings.title': 'Sozlamalar',
  'settings.save': 'Saqlash',
  'settings.saveConfirm': 'Sozlamalarni saqlaysizmi?',
  'settings.saved': 'Sozlamalar saqlandi',
  'settings.fillForm': "Barcha maydonlarni to'ldiring",
  'settings.commission': 'Komissiya',
  'settings.commissionHelp': "Har bir sayohat turidan olinadigan komissiya foizi",
  'settings.intercityCommission': 'Shaharlararo komissiya',
  'settings.interregionCommission': 'Viloyatlararo komissiya',
  'settings.postageCommission': 'Pochta komissiyasi',
  'settings.cargoCommission': 'Yuk komissiyasi',
  'settings.autoFind': 'Avto-qidiruv',
  'settings.autoFindHelp': "Haydovchilarni avtomatik qidirish sozlamalari",
  'settings.offerTimeout': 'Taklif kutish vaqti',
  'settings.progressiveOffer': 'Progressiv taklif',
  'settings.maxDrivers': 'Maksimal haydovchilar',
  'settings.searchRadius': 'Qidiruv radiusi',
  'settings.negotiation': 'Muzokara',
  'settings.negotiationHelp': 'Narx muzokara sozlamalari',
  'settings.maxCounterOffers': "Maksimal qarama-qarshi takliflar",
  'settings.counterOfferTimeout': 'Qarama-qarshi taklif kutish vaqti',
  'settings.driverSettings': 'Haydovchi sozlamalari',
  'settings.driverSettingsHelp': 'Haydovchilar uchun umumiy sozlamalar',
  'settings.minRating': 'Minimal reyting',
  'settings.maxCancellations': 'Maksimal bekor qilishlar',
  'settings.blockDuration': 'Bloklash muddati',
  'settings.cancellationPenalty': 'Bekor qilish jarimasi',
  'settings.surgePricing': 'Surge narxlash',
  'settings.surgePricingHelp': "Yuqori talab vaqtidagi dinamik narxlash",
  'settings.enabled': 'Yoqilgan',
  'settings.surgeThreshold': 'Surge chegarasi',
  'settings.surgeMin': 'Minimal surge',
  'settings.surgeMax': 'Maksimal surge',
  'settings.nightPricing': 'Tungi narxlash',
  'settings.nightPricingHelp': "Tungi soatlarda qo'shimcha narxlash",
  'settings.nightMultiplier': 'Tungi koeffitsient',
  'settings.nightStart': 'Tungi boshlanish',
  'settings.nightEnd': 'Tungi tugash',
  'settings.nightTimeHint': 'Format: HH:MM (masalan, 22:00)',
  'settings.referralBonuses': 'Referal bonuslar',
  'settings.referralBonusesHelp': "Referal dasturi bonus sozlamalari",
  'settings.referralClient': 'Mijoz uchun bonus',
  'settings.referralDriver': 'Haydovchi uchun bonus',
  'settings.clientSettings': 'Mijoz sozlamalari',
  'settings.clientSettingsHelp': 'Mijozlar uchun umumiy sozlamalar',
  'settings.clientCancellationPenalty': 'Mijoz bekor qilish jarimasi',
  'settings.clientNoShowWait': 'Kelmasa kutish vaqti',
  'settings.postageLimits': 'Pochta va yuk limitlari',
  'settings.postageLimitsHelp': 'Pochta va yuk yetkazish chegaralari',
  'settings.maxDestinations': 'Maksimal manzillar',
  'settings.maxWeight': "Maksimal og'irlik",
  'settings.limits': 'Limitlar',
  'settings.limitsHelp': 'Umumiy tizim chegaralari',
  'settings.maxTripDistance': 'Maksimal sayohat masofasi',
  'settings.locationUpdateInterval': 'Joylashuv yangilash oralig\'i',

  // ===== NOTIFICATIONS =====
  'notifications.title': 'Bildirishnomalar',
  'notifications.send': 'Bildirishnoma yuborish',
  'notifications.sendTitle': 'Bildirishnoma yuborish',
  'notifications.targetType': "Kimga yuborish",
  'notifications.allUsers': 'Barcha foydalanuvchilarga',
  'notifications.allDrivers': 'Barcha haydovchilarga',
  'notifications.byRegion': "Viloyat bo'yicha",
  'notifications.singleUser': 'Bitta foydalanuvchi',
  'notifications.regionLabel': 'Viloyat',
  'notifications.selectRegion': 'Viloyatni tanlang',
  'notifications.userId': 'Foydalanuvchi ID',
  'notifications.enterUserId': 'Foydalanuvchi ID kiriting',
  'notifications.notificationTitle': 'Sarlavha',
  'notifications.titlePlaceholder': 'Bildirishnoma sarlavhasi...',
  'notifications.body': 'Matn',
  'notifications.bodyPlaceholder': 'Bildirishnoma matni...',
  'notifications.schedule': 'Vaqtni belgilash',
  'notifications.cancelSchedule': 'Rejani bekor qilish',
  'notifications.sendNow': 'Hozir yuborish',
  'notifications.scheduledSend': 'Rejalashtirilgan yuborish',
  'notifications.selectTime': 'Vaqtni tanlang',
  'notifications.willSendNow': 'Hozir yuboriladi',
  'notifications.willSendScheduled': 'Belgilangan vaqtda yuboriladi',
  'notifications.broadcastConfirm': "Ommaviy bildirishnoma yuborasizmi?",
  'notifications.broadcastToUsers': 'Barcha foydalanuvchilarga yuboriladi',
  'notifications.broadcastToDrivers': 'Barcha haydovchilarga yuboriladi',
  'notifications.sentSuccess': 'Bildirishnoma yuborildi',
  'notifications.scheduledSuccess': 'Bildirishnoma rejalashtirildi',
  'notifications.sendError': 'Yuborishda xatolik',
  'notifications.stats.totalSent': 'Jami yuborilgan',
  'notifications.stats.delivered': 'Yetkazilgan',
  'notifications.stats.read': "O'qilgan",
  'notifications.stats.todaySent': 'Bugun yuborilgan',
  'notifications.historyTab': 'Tarix',
  'notifications.templatesTab': 'Shablonlar',
  'notifications.templateName': 'Shablon nomi',
  'notifications.templateNamePlaceholder': 'Shablon nomini kiriting...',
  'notifications.category': 'Kategoriya',
  'notifications.categoryPromo': 'Reklama',
  'notifications.categoryNews': 'Yangiliklar',
  'notifications.categorySystem': 'Tizim',
  'notifications.categoryReminder': 'Eslatma',
  'notifications.newTemplate': 'Yangi shablon',
  'notifications.editTemplate': 'Shablonni tahrirlash',
  'notifications.templateCreated': 'Shablon yaratildi',
  'notifications.templateUpdated': 'Shablon yangilandi',
  'notifications.templateDeleted': "Shablon o'chirildi",
  'notifications.templateDeleteError': "Shablonni o'chirishda xatolik",
  'notifications.recipients': 'Qabul qiluvchilar',
  'notifications.sentCount': 'Yuborilgan',
  'notifications.deliveredCount': 'Yetkazilgan',
  'notifications.readCount': "O'qilgan",
  'notifications.sender': 'Yuboruvchi',

  // ===== SUPPORT =====
  'support.title': 'Murojatlar',
  'support.ticketDetails': 'Murojat tafsilotlari',
  'support.relatedTrip': 'Bog\'langan sayohat',
  'support.viewTrip': "Sayohatni ko'rish",
  'support.viewFullTrip': "Sayohatni to'liq ko'rish",
  'support.messages': 'Xabarlar',
  'support.replySection': 'Javob yozish',
  'support.replyPlaceholder': 'Javobingizni yozing...',
  'support.replySuccess': 'Javob yuborildi',
  'support.resolveSuccess': 'Murojat hal qilindi',
  'support.resolveButton': 'Hal qilish',
  'support.ticketSubject': 'Mavzu',
  'support.ticketUser': 'Foydalanuvchi',
  'support.ticketStatus': 'Holat',
  'support.ticketDate': 'Sana',
  'support.statusOpen': 'Ochiq',
  'support.statusInProgress': 'Jarayonda',
  'support.statusResolved': 'Hal qilingan',
  'support.statusClosed': 'Yopilgan',

  // ===== EMERGENCY =====
  'emergency.title': 'Favqulotda chatlar',
  'emergency.alert': 'Favqulotda xabar',
  'emergency.alertDescription': "Foydalanuvchi favqulotda yordam so'radi",
  'emergency.lastMessage': 'Oxirgi xabar',
  'emergency.ctrlEnterHint': 'Yuborish uchun Ctrl+Enter bosing',

  // ===== SUGGESTIONS =====
  'suggestions.title': 'Takliflar',
  'suggestions.statusNew': 'Yangi',
  'suggestions.statusUnderReview': "Ko'rib chiqilmoqda",
  'suggestions.statusAccepted': 'Qabul qilingan',
  'suggestions.statusClosed': 'Yopilgan',
  'suggestions.accept': 'Qabul qilish',
  'suggestions.replySection': 'Javob yozish',
  'suggestions.category': 'Kategoriya',
  'suggestions.preview': 'Matn',
  'suggestions.content': 'Taklif matni',

  // ===== PAYMENTS =====
  'payments.title': "To'lovlar",
  'payments.searchPlaceholder': "To'lovlarni qidirish...",
  'payments.paymentDetails': "To'lov tafsilotlari",
  'payments.refundConfirm': "To'lovni qaytarasizmi?",
  'payments.refundButton': 'Qaytarish',
  'payments.refundSuccess': "To'lov muvaffaqiyatli qaytarildi",
  'payments.refundError': "To'lovni qaytarishda xatolik",
  'payments.loadError': "To'lovlarni yuklashda xatolik",
  'payments.transactionLoadError': "Tranzaksiyalarni yuklashda xatolik",
  'payments.transactionHistory': 'Tranzaksiyalar tarixi',
  'payments.originalAmount': 'Asl miqdor',
  'payments.bonusUsed': 'Ishlatilgan bonus',
  'payments.promoDiscount': 'Promo chegirma',
  'payments.finalAmount': 'Yakuniy miqdor',
  'payments.externalId': 'Tashqi ID',
  'payments.completedAt': 'Yakunlangan vaqt',
  'payments.statusPending': 'Kutilmoqda',
  'payments.statusProcessing': 'Jarayonda',
  'payments.statusCompleted': 'Yakunlangan',
  'payments.statusFailed': 'Xatolik',
  'payments.statusRefunded': 'Qaytarilgan',

  // ===== ANALYTICS =====
  'analytics.title': 'Analitika',
  'analytics.exportExcel': 'Excel eksport',
  'analytics.dateRange': 'Sana oralig\'i',
  'analytics.revenueTab': 'Daromad',
  'analytics.tripsTab': 'Sayohatlar',
  'analytics.usersTab': 'Foydalanuvchilar',
  'analytics.driversTab': 'Haydovchilar',
  'analytics.regionsTab': 'Viloyatlar',
  'analytics.totalRevenue': 'Jami daromad',
  'analytics.avgDaily': "O'rtacha kunlik",
  'analytics.growth': "O'sish",
  'analytics.revenueChart': 'Daromad grafigi',
  'analytics.noRevenueData': "Daromad ma'lumotlari yo'q",
  'analytics.totalTrips': 'Jami sayohatlar',
  'analytics.completedTrips': 'Yakunlangan sayohatlar',
  'analytics.cancelledTrips': 'Bekor qilingan sayohatlar',
  'analytics.tripsChart': 'Sayohatlar grafigi',
  'analytics.noTripsData': "Sayohat ma'lumotlari yo'q",
  'analytics.tripsByType': "Turi bo'yicha sayohatlar",
  'analytics.totalUsers': 'Jami foydalanuvchilar',
  'analytics.totalDrivers': 'Jami haydovchilar',
  'analytics.userGrowth': "Foydalanuvchilar o'sishi",
  'analytics.newUsers': 'Yangi foydalanuvchilar',
  'analytics.newDrivers': 'Yangi haydovchilar',
  'analytics.avgRating': "O'rtacha reyting",
  'analytics.avgTrips': "O'rtacha sayohatlar",
  'analytics.driverStatus': 'Haydovchi holati',
  'analytics.topDrivers': 'Eng yaxshi haydovchilar',
  'analytics.driverPerformance': 'Haydovchi samaradorligi',
  'analytics.avgResponseTime': "O'rtacha javob vaqti",
  'analytics.acceptanceRate': 'Qabul qilish foizi',
  'analytics.completionRate': 'Yakunlash foizi',
  'analytics.regionTrips': 'Viloyat sayohatlari',
  'analytics.regionRevenue': 'Viloyat daromadi',
  'analytics.regionDrivers': 'Viloyat haydovchilari',
  'analytics.regionStats': 'Viloyat statistikasi',
  // Bus analytics
  'analytics.busTitle': 'Avtobus analitikasi',
  'analytics.paidAmount': "To'langan miqdor",
  'analytics.unpaidAmount': "To'lanmagan miqdor",
  'analytics.commission': 'Komissiya',
  'analytics.bookedSeats': 'Band qilingan joylar',
  'analytics.totalSeats': "Jami o'rindiqlar",
  'analytics.occupancyRate': 'Bandlik darajasi',
  'analytics.routesTab': "Yo'nalishlar",
  'analytics.companiesTab': 'Kompaniyalar',
  'analytics.revenueByRoute': "Yo'nalish bo'yicha daromad",
  'analytics.routeStats': "Yo'nalish statistikasi",
  'analytics.revenueByCompany': "Kompaniya bo'yicha daromad",
  'analytics.companyStats': 'Kompaniya statistikasi',
  'analytics.loadError': "Analitikani yuklashda xatolik",

  // ===== ANALYTICS v2 — full dashboard =====
  'analytics.refresh': 'Yangilash',
  'analytics.period': 'Davr',
  'analytics.periodDaily': 'Kunlik',
  'analytics.periodWeekly': 'Haftalik',
  'analytics.periodMonthly': 'Oylik',
  'analytics.noData': "Ma'lumot yo'q",

  // KPI tiles
  'analytics.kpi.grossRevenue': 'Yalpi daromad',
  'analytics.kpi.grossRevenueHint': 'Mijozlar to\'lagan (TRIP_PAYMENT)',
  'analytics.kpi.grossCommission': 'Komissiya',
  'analytics.kpi.grossCommissionHint': 'Platformaning ulushi (to\'lovlarsiz)',
  'analytics.kpi.netMargin': 'Sof foyda',
  'analytics.kpi.netMarginHint': 'Komissiya − kompensatsiyalar − bonuslar − promo − qaytarilganlar',
  'analytics.kpi.driverIncentives': 'Haydovchi kompensatsiyalari',
  'analytics.kpi.userBonuses': 'Foydalanuvchi bonuslari',
  'analytics.kpi.promoDiscounts': 'Promo chegirmalar',
  'analytics.kpi.refunds': 'Qaytarilganlar',
  'analytics.kpi.totalTrips': 'Jami sayohatlar',
  'analytics.kpi.completionRate': 'Yakunlash foizi',
  'analytics.kpi.newUsers': 'Yangi foydalanuvchilar',
  'analytics.kpi.newDrivers': 'Yangi haydovchilar',
  'analytics.kpi.verifiedDrivers': 'Tasdiqlangan haydovchilar',
  'analytics.kpi.avgRating': "O'rtacha reyting",
  'analytics.kpi.avgTripPrice': "O'rtacha narx",
  'analytics.kpi.avgTripDistance': "O'rtacha masofa (km)",
  'analytics.kpi.activeNow': 'Hozir faol',
  'analytics.kpi.activeDrivers': 'Faol haydovchilar',
  'analytics.kpi.activeTrips': 'Faol sayohatlar',

  // Tabs
  'analytics.tab.overview': 'Umumiy',
  'analytics.tab.revenue': 'Daromad',
  'analytics.tab.trips': 'Sayohatlar',
  'analytics.tab.users': 'Foydalanuvchilar',
  'analytics.tab.drivers': 'Haydovchilar',
  'analytics.tab.regions': 'Viloyatlar',
  'analytics.tab.promoRatings': 'Promo va reytinglar',
  'analytics.tab.operations': 'Operatsiyalar',

  // Charts / sections
  'analytics.chart.grossVsNet': 'Yalpi daromad va sof foyda',
  'analytics.chart.revenueByService': 'Xizmat turi bo\'yicha daromad',
  'analytics.chart.paymentMethodShare': "To'lov usullari",
  'analytics.chart.tripsBreakdown': 'Kunlik sayohatlar',
  'analytics.chart.tripsByService': 'Xizmat turi bo\'yicha sayohatlar',
  'analytics.chart.tariffBreakdown': 'Tariflar bo\'yicha sayohatlar',
  'analytics.chart.tripsByHour': 'Soat bo\'yicha sayohatlar',
  'analytics.chart.tripsByDayOfWeek': 'Hafta kuni bo\'yicha sayohatlar',
  'analytics.chart.topRoutes': 'Eng ommabop yo\'nalishlar',
  'analytics.chart.serviceBreakdown': 'Xizmatlar bo\'yicha taqsimot',
  'analytics.chart.ratingDistribution': 'Reyting taqsimoti',
  'analytics.chart.activityScoreBuckets': 'Faollik bali taqsimoti',
  'analytics.chart.usersByRegion': 'Viloyat bo\'yicha foydalanuvchilar',

  // Payouts
  'analytics.payouts.title': "To'lovlar — platformadan chiqayotgan pullar",
  'analytics.payouts.driverIncentives': 'Haydovchi kompensatsiyalari',
  'analytics.payouts.userReferrals': 'Foydalanuvchi referral bonuslari',
  'analytics.payouts.bonusCredits': 'Bonus qo\'shilishlari',
  'analytics.payouts.bonusDebits': 'Bonus kamayishlari',
  'analytics.payouts.refunds': 'Qaytarilganlar',
  'analytics.payouts.totalPaidOut': "Jami chiqim",
  'analytics.payouts.topPrograms': 'Eng faol rag\'batlantirish dasturlari',
  'analytics.payouts.recipients': 'Qabul qiluvchilar',
  'analytics.payouts.adminAdjustments': 'Admin tomonidan qo\'lda o\'zgartirishlar',

  // Tables
  'analytics.table.topByTrips': 'Sayohatlar bo\'yicha top',
  'analytics.table.topByEarnings': 'Daromad bo\'yicha top',
  'analytics.table.topPromoCodes': 'Top promo kodlar',
  'analytics.table.transactionTypes': 'Tranzaksiya turlari',
  'analytics.table.routeFrom': 'Qayerdan',
  'analytics.table.routeTo': 'Qayerga',
  'analytics.table.code': 'Kod',
  'analytics.table.redemptions': 'Qo\'llanilgan',
  'analytics.table.totalDiscount': 'Jami chegirma',
  'analytics.table.region': 'Viloyat',
  'analytics.table.trips': 'Sayohatlar',
  'analytics.table.grossRevenue': 'Yalpi daromad',
  'analytics.table.netRevenue': 'Sof daromad',
  'analytics.table.drivers': 'Haydovchilar',
  'analytics.table.clients': 'Mijozlar',
  'analytics.table.completedTrips': 'Yakunlangan',
  'analytics.table.earnings': 'Daromad',
  'analytics.table.rating': 'Reyting',
  'analytics.table.totalTrips': 'Jami sayohatlar',
  'analytics.table.activityScore': 'Faollik bali',
  'analytics.table.status': 'Holat',
  'analytics.table.count': 'Miqdor',
  'analytics.table.type': 'Turi',
  'analytics.table.amount': 'Summa',
  'analytics.table.recipients': 'Qabul qiluvchilar',
  'analytics.table.programName': 'Dastur nomi',
  'analytics.table.bonusAmount': 'Bonus miqdori',

  // Operations
  'analytics.ops.verification': 'Hujjatlar tekshiruvi',
  'analytics.ops.pendingDocs': 'Kutilayotgan',
  'analytics.ops.approvedDocs': 'Tasdiqlangan',
  'analytics.ops.rejectedDocs': 'Rad etilgan',
  'analytics.ops.avgReviewHours': "O'rtacha tekshiruv vaqti (soat)",
  'analytics.ops.support': "Qo'llab-quvvatlash",
  'analytics.ops.openTickets': 'Ochiq',
  'analytics.ops.inProgressTickets': 'Jarayonda',
  'analytics.ops.resolvedTickets': 'Hal qilingan',
  'analytics.ops.avgResolutionHours': "O'rtacha hal qilish vaqti (soat)",
  'analytics.ops.newTicketsInPeriod': 'Davrdagi yangi murojaatlar',
  'analytics.ops.restingNow': 'Dam olayotganlar',
  'analytics.ops.cancellationRate': 'Haydovchi bekor qilish foizi',
  'analytics.ops.walletBalances': 'Hamyon balansi (jami)',
  'analytics.ops.bonusBalances': 'Bonus balansi (jami)',
  'analytics.ops.walletTopups': 'Hamyonga to\'ldirishlar',
  'analytics.ops.walletWithdrawals': 'Hamyondan yechishlar',

  // Misc
  'analytics.hours': 'soat',
  'analytics.trips': 'ta',
  'analytics.users': 'kishi',
  'analytics.vs': 'nisbatan',
  'analytics.prevPeriod': 'oldingi davr',

  // ===== STAFF =====
  'staff.title': 'Xodimlar',
  'staff.newStaff': 'Yangi xodim',
  'staff.basicInfo': "Asosiy ma'lumotlar",
  'staff.login': 'Login',
  'staff.password': 'Parol',
  'staff.newPassword': 'Yangi parol',
  'staff.fullName': "To'liq ism",
  'staff.phone': 'Telefon',
  'staff.activeStatus': 'Faol holat',
  'staff.permissions': 'Ruxsatnomalar',
  'staff.noPermissions': "Ruxsatnomalar yo'q",
  'staff.permissionGroups.users': 'Foydalanuvchilar',
  'staff.permissionGroups.drivers': 'Haydovchilar',
  'staff.permissionGroups.documents': 'Hujjatlar',
  'staff.permissionGroups.trips': 'Sayohatlar',
  'staff.permissionGroups.payments': "To'lovlar",
  'staff.permissionGroups.support': "Qo'llab-quvvatlash",
  'staff.permissionGroups.faq': 'FAQ',
  'staff.permissionGroups.promo': 'Promo kodlar',
  'staff.permissionGroups.settings': 'Sozlamalar',
  'staff.permissionGroups.staff': 'Xodimlar',
  'staff.actions.read': "Ko'rish",
  'staff.actions.create': 'Yaratish',
  'staff.actions.update': 'Tahrirlash',
  'staff.actions.delete': "O'chirish",
  'staff.actions.block': 'Bloklash',
  'staff.actions.verify': 'Tasdiqlash',
  'staff.actions.review': "Ko'rib chiqish",
  'staff.actions.reply': 'Javob berish',
  'staff.actions.resolve': 'Hal qilish',
  'staff.actions.cancel': 'Bekor qilish',
  'staff.lastLogin': 'Oxirgi kirish',
  'staff.activityLog': 'Faoliyat jurnali',

  // ===== PROMO CODES =====
  'promo.title': 'Promo kodlar',
  'promo.newPromo': 'Yangi promo kod',
  'promo.code': 'Kod',
  'promo.type': 'Turi',
  'promo.value': 'Qiymat',
  'promo.usage': 'Ishlatilgan',
  'promo.validity': 'Amal qilish muddati',
  'promo.percentage': 'Foiz',
  'promo.fixedAmount': 'Belgilangan miqdor',
  'promo.maxUsages': 'Maksimal ishlatishlar',
  'promo.minTripAmount': "Minimal sayohat miqdori",
  'promo.maxDiscount': 'Maksimal chegirma',
  'promo.startDate': 'Boshlanish sanasi',
  'promo.endDate': 'Tugash sanasi',
  'promo.usageHistory': 'Ishlatish tarixi',
  'promo.totalUsages': 'Jami ishlatishlar',
  'promo.discount': 'Chegirma',
  'promo.usedAt': 'Ishlatilgan vaqt',
  'promo.toggleConfirm': 'Promo kod holatini o\'zgartirasizmi?',
  'promo.editPromo': 'Promo kodni tahrirlash',

  // ===== FAQ =====
  'faq.title': "Ko'p so'raladigan savollar",
  'faq.newFaq': 'Yangi savol',
  'faq.order': 'Tartib',
  'faq.question': 'Savol',
  'faq.answer': 'Javob',
  'faq.category': 'Kategoriya',
  'faq.questionUz': "Savol (O'zbekcha)",
  'faq.answerUz': "Javob (O'zbekcha)",
  'faq.questionRu': 'Savol (Ruscha)',
  'faq.answerRu': 'Javob (Ruscha)',
  'faq.questionEn': 'Savol (Inglizcha)',
  'faq.answerEn': 'Javob (Inglizcha)',
  'faq.sortOrder': 'Tartiblash raqami',
  'faq.visible': "Ko'rinadi",
  'faq.hidden': 'Yashirin',

  // ===== CANCELLATION REASONS =====
  'cancelReasons.title': 'Bekor qilish sabablari',
  'cancelReasons.new': 'Yangi sabab',
  'cancelReasons.type': 'Turi',
  'cancelReasons.reasonUz': "Sabab (O'zbekcha)",
  'cancelReasons.reasonRu': 'Sabab (Ruscha)',
  'cancelReasons.reasonEn': 'Sabab (Inglizcha)',
  'cancelReasons.clientType': 'Mijoz uchun',
  'cancelReasons.driverType': 'Haydovchi uchun',

  // ===== APP UPDATES =====
  'appUpdates.title': 'Ilova yangilanishlari',
  'appUpdates.new': 'Yangi yangilanish',
  'appUpdates.version': 'Versiya',
  'appUpdates.mandatory': 'Majburiy',
  'appUpdates.optional': 'Ixtiyoriy',
  'appUpdates.storeUrls': "Do'kon havolalari",
  'appUpdates.playStoreUrl': 'Play Store havolasi',
  'appUpdates.appStoreUrl': 'App Store havolasi',
  'appUpdates.releaseNotesUz': "Yangiliklar (O'zbekcha)",
  'appUpdates.releaseNotesRu': 'Yangiliklar (Ruscha)',
  'appUpdates.releaseNotesEn': 'Yangiliklar (Inglizcha)',
  'appUpdates.releaseProcess': 'Chiqarish jarayoni',

  // ===== CAR BRANDS =====
  'carBrands.title': 'Avtomobil markalari',
  'carBrands.brandsTab': 'Markalar',
  'carBrands.modelsTab': 'Modellar',
  'carBrands.brandName': 'Marka nomi',
  'carBrands.modelName': 'Model nomi',
  'carBrands.modelCount': 'Modellar soni',
  'carBrands.sortOrder': 'Tartib raqami',
  'carBrands.newBrand': 'Yangi marka',
  'carBrands.editBrand': 'Markani tahrirlash',
  'carBrands.newModel': 'Yangi model',
  'carBrands.editModel': 'Modelni tahrirlash',
  'carBrands.selectBrand': 'Markani tanlang',

  // ===== INCENTIVES =====
  'incentives.title': "Rag'batlantirish dasturlari",
  'incentives.newProgram': 'Yangi dastur',
  'incentives.programName': 'Dastur nomi',
  'incentives.goal': 'Maqsad',
  'incentives.period': 'Davr',
  'incentives.tripTypes': 'Sayohat turlari',
  'incentives.participants': 'Ishtirokchilar',
  'incentives.completedCount': 'Bajarilgan soni',
  'incentives.totalPrograms': 'Jami dasturlar',
  'incentives.activePrograms': 'Faol dasturlar',
  'incentives.totalParticipants': 'Jami ishtirokchilar',
  'incentives.totalBonusPaid': "Jami to'langan bonus",
  'incentives.details': 'Tafsilotlar',
  'incentives.driverProgress': "Haydovchi ko'rsatkichlari",
  'incentives.awardBonus': "Bonus to'lash",
  'incentives.bonusAwarded': 'Bonus berildi',
  'incentives.bonusPaid': "Bonus to'landi",
  'incentives.tripCountTarget': "Maqsadli sayohat soni",
  'incentives.bonusAmount': 'Bonus miqdori',
  'incentives.dateRange': 'Sana oralig\'i',
  'incentives.expired': 'Muddati tugagan',

  // ===== REFERRALS =====
  'referrals.title': 'Referal dasturi',
  'referrals.config': 'Sozlamalar',
  'referrals.referrer': 'Taklif qiluvchi',
  'referrals.referred': 'Taklif qilingan',
  'referrals.totalReferrals': 'Jami referallar',
  'referrals.completed': 'Yakunlangan',
  'referrals.pending': 'Kutilmoqda',
  'referrals.thisMonth': 'Shu oy',
  'referrals.conversionRate': 'Konversiya foizi',
  'referrals.totalBonusPaid': "Jami to'langan bonus",
  'referrals.listTab': "Ro'yxat",
  'referrals.topReferrersTab': 'Eng ko\'p taklif qilganlar',
  'referrals.configTab': 'Sozlamalar',
  'referrals.payBonus': "Bonus to'lash",
  'referrals.bonusPaid': "Bonus to'landi",
  'referrals.configStatus': 'Dastur holati',
  'referrals.minTrips': "Minimal sayohatlar soni",
  'referrals.passengerReferrerBonus': "Yo'lovchi taklif qiluvchi bonusi",
  'referrals.passengerReferredBonus': "Yo'lovchi taklif qilingan bonusi",
  'referrals.driverReferrerBonus': 'Haydovchi taklif qiluvchi bonusi',
  'referrals.driverReferredBonus': 'Haydovchi taklif qilingan bonusi',
  'referrals.passengerBonuses': "Yo'lovchi bonuslari",
  'referrals.driverBonuses': 'Haydovchi bonuslari',

  // ===== PRICING =====
  'pricing.title': 'Narxlash',
  'pricing.routesTab': "Yo'nalishlar",
  'pricing.postageTab': 'Pochta',
  'pricing.surgeTab': 'Surge',
  'pricing.settingsTab': 'Sozlamalar',
  'pricing.basePricing': 'Asosiy narxlash',
  'pricing.defaultPricePerKm': 'Har km uchun standart narx',
  'pricing.newRoute': "Yangi yo'nalish",
  'pricing.editRoute': "Yo'nalishni tahrirlash",
  'pricing.fromRegion': 'Qayerdan (viloyat)',
  'pricing.toRegion': 'Qayerga (viloyat)',
  'pricing.fromCity': 'Qayerdan (shahar)',
  'pricing.toCity': 'Qayerga (shahar)',
  'pricing.tariffPrices': 'Tarif narxlari',
  'pricing.econom': 'Ekonom',
  'pricing.standard': 'Standart',
  'pricing.comfort': 'Komfort',
  'pricing.business': 'Biznes',
  'pricing.sevenPlus': '7+ joylik',
  'pricing.minPrice': 'Minimal narx',
  'pricing.maxPrice': 'Maksimal narx',
  'pricing.surgeMultiplier': 'Surge koeffitsienti',
  'pricing.surgeRegion': 'Surge viloyati',
  'pricing.multiplier': 'Koeffitsient',
  'pricing.demandRatio': 'Talab darajasi',
  'pricing.recalculate': 'Qayta hisoblash',
  'pricing.recalculateConfirm': 'Narxlarni qayta hisoblaysizmi?',
  'pricing.autoCalculationInfo': 'Narxlar avtomatik hisoblanadi',
  'pricing.priceOrderError': "Narxlar tartibda bo'lishi kerak: Ekonom < Standart < Komfort < Biznes",
  'pricing.basePrice': 'Asosiy narx',
  'pricing.pricePerKm': 'Har km narxi',
  'pricing.nightTimeHint': 'Format: HH:MM (masalan, 22:00)',
  'pricing.surgeMinMaxError': "Maksimal narx minimaldan katta bo'lishi kerak",
  'pricing.maxGteMin': "Maksimal narx minimaldan katta bo'lishi kerak",

  // ===== LOCATIONS =====
  'locations.title': 'Joylar',
  'locations.regionsTab': 'Viloyatlar',
  'locations.citiesDistrictsTab': 'Shahar va tumanlar',
  'locations.popularTab': 'Mashhur joylar',
  'locations.boundariesTab': 'Chegaralar',
  'locations.regions': 'Viloyatlar',
  'locations.cities': 'Shaharlar',
  'locations.districts': 'Tumanlar',
  'locations.nameUz': "Nom (O'zbekcha)",
  'locations.nameRu': 'Nom (Ruscha)',
  'locations.nameEn': 'Nom (Inglizcha)',
  'locations.code': 'Kod',
  'locations.hasBoundary': 'Chegara mavjud',
  'locations.citiesCount': 'Shaharlar soni',
  'locations.districtsCount': 'Tumanlar soni',
  'locations.boundary': 'Chegara',
  'locations.viewOnMap': "Xaritada ko'rish",
  'locations.uploadGeoJson': 'GeoJSON yuklash',
  'locations.deleteBoundary': "Chegarani o'chirish",
  'locations.importBoundaries': 'Chegaralarni import qilish',
  'locations.matchConfidence': "Moslik darajasi",
  'locations.popularDestinations': 'Mashhur manzillar',
  'locations.icon': 'Belgi',
  'locations.coordinates': 'Koordinatalar',
  'locations.lat': 'Kenglik',
  'locations.lng': 'Uzunlik',
  'locations.boundariesMap': 'Chegaralar xaritasi',
  'locations.showRegions': "Viloyatlarni ko'rsatish",
  'locations.showCities': "Shaharlarni ko'rsatish",
  'locations.showDistricts': "Tumanlarni ko'rsatish",

  // ----- Locations page extended (page-level strings) -----
  'locations.id': 'ID',
  'locations.actions': 'Amallar',
  'locations.type': 'Turi',
  'locations.yes': 'Bor',
  'locations.no': "Yo'q",
  'locations.active': 'Faol',
  'locations.inactive': 'Nofaol',
  'locations.status': 'Holat',
  'locations.sortOrder': 'Tartib',
  'locations.sortOrderNumber': 'Tartib raqami',
  'locations.region': 'Viloyat',
  'locations.city': 'Shahar',
  'locations.district': 'Tuman',
  'locations.mapTab': 'Xarita',
  'locations.locationManagement': 'Joylar boshqaruvi',
  'locations.save': 'Saqlash',
  'locations.create': 'Yaratish',
  'locations.cancel': 'Bekor qilish',
  'locations.add': "Qo'shish",
  'locations.loading': 'Yuklanmoqda...',
  'locations.refresh': 'Yangilash',
  'locations.retry': 'Qayta urinish',
  'locations.errorLabel': 'Xatolik',
  'locations.errorOccurred': 'Xatolik yuz berdi',
  'locations.dataLoadError': "Ma'lumotlarni yuklashda xatolik",
  'locations.regionsLoadError': 'Viloyatlarni yuklashda xatolik',
  'locations.boundariesLoadError': 'Chegaralarni yuklashda xatolik',
  'locations.confirmDelete': "O'chirishni tasdiqlaysizmi?",
  'locations.enterName': 'Nomni kiriting',
  'locations.enterValue': 'Kiriting',
  'locations.selectRegion': 'Viloyatni tanlang',
  'locations.selectCity': 'Shaharni tanlang',
  'locations.selectDistrict': 'Tumanni tanlang',
  'locations.filters': 'Filtrlar:',
  'locations.newRegion': 'Yangi viloyat',
  'locations.editRegion': 'Viloyatni tahrirlash',
  'locations.regionCreated': 'Viloyat yaratildi',
  'locations.regionUpdated': 'Viloyat yangilandi',
  'locations.regionDeleted': "Viloyat o'chirildi",
  'locations.newCityDistrict': 'Yangi shahar/tuman',
  'locations.editCity': 'Shaharni tahrirlash',
  'locations.editDistrict': 'Tumanni tahrirlash',
  'locations.cityCreated': 'Shahar yaratildi',
  'locations.cityUpdated': 'Shahar yangilandi',
  'locations.cityDeleted': "Shahar o'chirildi",
  'locations.districtCreated': 'Tuman yaratildi',
  'locations.districtUpdated': 'Tuman yangilandi',
  'locations.districtDeleted': "Tuman o'chirildi",
  'locations.citiesWord': 'shahar',
  'locations.districtsWord': 'tuman',
  'locations.newDestination': 'Yangi manzil',
  'locations.newPopularDestination': 'Yangi mashhur manzil',
  'locations.editDestination': 'Manzilni tahrirlash',
  'locations.destinationCreated': 'Manzil yaratildi',
  'locations.destinationUpdated': 'Manzil yangilandi',
  'locations.destinationDeleted': "Manzil o'chirildi",
  'locations.addFirstDestination': "Birinchi manzilni qo'shish",
  'locations.noRegionsFound': 'Viloyatlar topilmadi',
  'locations.noCitiesOrDistrictsInRegion': "Bu viloyatda shahar yoki tuman mavjud emas",
  'locations.noPopularInCity': "Bu shaharda hali mashhur manzillar yo'q.",
  'locations.noPopularInDistrict': "Bu tumanda hali mashhur manzillar yo'q.",
  'locations.noBoundariesFound': "Hech qanday chegara topilmadi. Avval viloyat, shahar yoki tumanlarga chegara qo'shing.",
  'locations.latitude': 'Kenglik (Latitude)',
  'locations.longitude': 'Uzunlik (Longitude)',
  'locations.optionalCode': 'Kod (ixtiyoriy)',
  'locations.optionalIconName': 'Ikonka nomi (ixtiyoriy)',
  'locations.totalDestinationsSummaryPrefix': 'Jami:',
  'locations.destinationsWord': 'ta mashhur manzil',
  'locations.regionsWord': 'viloyat',
  'locations.boundariesWord': 'ta chegara',

  // ===== LOGIN =====
  'login.title': 'Admin panelga kirish',
  'login.username': 'Login',
  'login.password': 'Parol',
  'login.submit': 'Kirish',
  'login.error': "Login yoki parol noto'g'ri",

  // ===== SERVICES =====
  'service.taxi': 'Taxi',
  'service.bus': 'Avtobus',
  'service.cargo': 'Yuk',
  'service.taxiDescription': 'Taksi xizmatlari boshqaruvi',
  'service.busDescription': 'Avtobus xizmatlari boshqaruvi',
  'service.cargoDescription': 'Yuk tashish xizmatlari boshqaruvi',
  'service.comingSoon': 'Tez kunda',

  // ===== FILTERS =====
  'filters.advancedFilter': "Kengaytirilgan filtr",
  'filters.clear': 'Tozalash',
  'filters.apply': "Qo'llash",
  'filters.verificationStatus': 'Tasdiqlash holati',
  'filters.driverVerified': 'Tasdiqlangan haydovchilar',
  'filters.tripStatistics': 'Sayohat statistikasi',
  'filters.tripCount': 'Sayohatlar soni',
  'filters.minTrips': 'Minimal sayohatlar',
  'filters.maxTrips': 'Maksimal sayohatlar',
  'filters.hasCompletedTrips': 'Yakunlangan sayohatlari bor',
  'filters.yesCompleted': 'Ha, bor',
  'filters.noCompleted': "Yo'q",
  'filters.minRating': 'Minimal reyting',
  'filters.maxRating': 'Maksimal reyting',
  'filters.registrationDate': "Ro'yxatdan o'tgan sana",
  'filters.from': 'Dan',
  'filters.to': 'Gacha',
  'filters.blockedUsers': 'Bloklangan foydalanuvchilar',
  'filters.onlyBlocked': 'Faqat bloklangan',
  'filters.onlyNotBlocked': 'Faqat bloklanmagan',
  'filters.vehicleStatus': 'Avtomobil holati',
  'filters.hasVehicle': 'Avtomobili bor',
  'filters.noVehicle': "Avtomobili yo'q",

  // ===== BUS MODULE =====
  'bus.companies': 'Kompaniyalar',
  'bus.trips': 'Reyslar',
  'bus.bookings': 'Buyurtmalar',
  'bus.staff': 'Xodimlar',
  'bus.settings': 'Sozlamalar',
  'bus.reports': 'Hisobotlar',
  'bus.analytics': 'Analitika',
  'bus.companyName': 'Kompaniya nomi',
  'bus.legalName': 'Yuridik nom',
  'bus.commission': 'Komissiya',
  'bus.tripCount': 'Reyslar soni',
  'bus.newCompany': 'Yangi kompaniya',
  'bus.blockCompany': 'Kompaniyani bloklash',
  'bus.unblockCompany': 'Kompaniyani faollashtirish',
  'bus.blockReason': 'Bloklash sababi',
  'bus.route': "Yo'nalish",
  'bus.departureTime': "Jo'nab ketish vaqti",
  'bus.arrivalTime': 'Kelish vaqti',
  'bus.seats': "O'rindiqlar",
  'bus.availableSeats': "Bo'sh o'rindiqlar",
  'bus.pricePerSeat': "Bir o'rindiq narxi",
  'bus.busType': 'Avtobus turi',
  'bus.busNumber': 'Avtobus raqami',
  'bus.standard': 'Standart',
  'bus.comfort': 'Komfort',
  'bus.vip': 'VIP',
  'bus.stations': 'Bekatlar',
  'bus.layouts': 'Joylashuvlar',
  'bus.seatEditor': "O'rindiq muharriri",
  'bus.bookingCode': 'Buyurtma kodi',
  'bus.passenger': "Yo'lovchi",
  'bus.seatNumbers': "O'rindiq raqamlari",
  'bus.totalPrice': 'Jami narx',
  'bus.confirmPayment': "To'lovni tasdiqlash",
  'bus.cancelBooking': 'Buyurtmani bekor qilish',
  'bus.cancelReason': 'Bekor qilish sababi',
  'bus.downloadPassengerList': "Yo'lovchilar ro'yxatini yuklab olish",
  'bus.createBooking': 'Buyurtma yaratish',
  'bus.stationName': 'Bekat nomi',
  'bus.address': 'Manzil',
  'bus.layoutName': 'Joylashuv nomi',
  'bus.totalSeats': "Jami o'rindiqlar",
  'bus.seatSchema': "O'rindiq sxemasi",

  // ===== DRIVER JOURNEY STAGES =====
  'drivers.pushNotification': 'Push',
  'drivers.journeyStages': "Ilova bo'yicha bosqichlar",
  'drivers.stageRegistration': "Ro'yxatdan o'tish",
  'drivers.stageNameEntered': 'Ism kiritilgan',
  'drivers.stageVehicleAdded': "Avtomobil qo'shilgan",
  'drivers.stageDocumentsUploaded': 'Hujjatlar yuklangan',
  'drivers.stageDocumentsApproved': 'Hujjatlar tasdiqlangan',
  'drivers.stageDriverVerified': 'Haydovchi tasdiqlangan',
  'drivers.stagePushEnabled': 'Push bildirishnoma',
  'drivers.stageFirstTrip': 'Birinchi sayohat',
  'drivers.stageCompleted': 'Bajarildi',
  'drivers.stagePending': 'Kutilmoqda',
  'drivers.stageFailed': 'Rad etilgan',
  'filters.hasPush': 'Push yoqilgan',
  'filters.noPush': "Push yo'q",
};
